import { useEffect, useState } from "react";
import { Create, SimpleForm, useDataProvider, useNotify, useRedirect } from "react-admin";
import { useLocation } from "react-router-dom";
import { EDUCATION_PREPARATORY, IdType, STUDENTS_PATH } from "utils/constants";
import { candidateRequests } from "api/candidateApi";
import { CircularProgress } from "@mui/material";

import BackButtonToolbar from "features/BackButtonToolbar";

import CandidateInfo from "./Sections/CandidateInfo";
import BirthAndEducationInfo from "./Sections/OtherInfo";

import { getStyle } from "customStyles/utils";
import { settings } from "app";
import { useNotifyError } from "utils/useNotifyError";

const CreatePreparatoryForm = ({ props, title }) => {
  const location = useLocation();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const redirect = useRedirect();
  const style = getStyle(settings.tenant);
  const notifyError = useNotifyError();

  const { candidacyId, citizenshipId, specialityId } = location?.state || {};

  const [userData, setData] = useState(null);
  const [loadingSend, setLoadingSend] = useState(false);

  useEffect(() => {
    dataProvider
      .customRequest(candidateRequests.getPreparatoryYearCandidateEnroll(candidacyId))
      .then(res => {
        setData(res?.data);
        // eslint-disable-next-line no-unused-vars
      })
      .catch(e => {
        notifyError(e);
        setData([]);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const convertData = (obj, keysToRemove = [], prefixesToRemove = []) => {
    const removedData = Object.fromEntries(
      Object.entries(obj)
        .filter(([key]) => !keysToRemove.includes(key) && !prefixesToRemove.some(prefix => key.startsWith(prefix)))
        .map(([key, value]) => {
          const dateKeys = ["birthDate", "orderDate"];

          if (typeof value === "string" && dateKeys.includes(key)) {
            value = value.split("T")[0];
          }
          if (typeof value === "object" && value !== null && dateKeys.includes(key)) {
            value = Object.fromEntries(
              Object.entries(value).map(([k, val]) => {
                return [k, val];
              }),
            );
          }
          return [key, value];
        }),
    );

    return removedData;
  };

  const handleSend = data => {
    setLoadingSend(true);

    return {
      ...convertData(data),
      candidacyId,
      candidateInfo: {
        ...data.candidateInfo,
        personId:
          data.candidateInfo.personIdType === IdType.PNF
            ? Number(data.candidateInfo.personId)
            : data.candidateInfo.personId,
        citizenship: data?.candidateInfo?.citizenship || citizenshipId,
        secondNameEn: data?.candidateInfo?.secondNameEn || "",
        secondNameBg: data?.candidateInfo?.secondNameBg || "",
      },
    };
  };

  return (
    <div style={loadingSend ? { opacity: 0.5 } : { opacity: 1 }}>
      {loadingSend && (
        <div style={style.loadingStyle.container}>
          <CircularProgress size={200} />
          <div style={style.loadingStyle.text}>Saving...</div>
        </div>
      )}

      {userData && (
        <Create
          {...props}
          title={title}
          transform={handleSend}
          resource={candidateRequests.enrollPreparatoryYearCandidate()}
          mutationOptions={{
            onSuccess: data => {
              setLoadingSend(false);
              if (data?.props?.facultyNumber !== undefined) {
                redirect(
                  `/${STUDENTS_PATH}/${EDUCATION_PREPARATORY}?filter={${JSON.stringify(
                    "facultyNumber",
                  )}:${JSON.stringify(data.props.facultyNumber)}}`,
                );
              } else {
                redirect(`/${STUDENTS_PATH}/${EDUCATION_PREPARATORY}`);
              }
            },
            onError: error => {
              setLoadingSend(false);
              notify(error.message, { type: "error" });
            },
          }}
          actions={<BackButtonToolbar />}
        >
          <SimpleForm>
            <CandidateInfo
              userData={userData}
              citizenshipId={citizenshipId}
            />

            {/* Място на раждане / Приет в */}
            <BirthAndEducationInfo
              userData={userData}
              specialityId={specialityId}
            />
          </SimpleForm>
        </Create>
      )}
    </div>
  );
};
export default CreatePreparatoryForm;
